// ** Third Party Components
import styled, { css } from "styled-components";

export const StyledSvgIconContainer = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	margin: 0 0.5rem 0 0;

	${({ $customMargin }) =>
		$customMargin &&
		css`
			margin: ${$customMargin};
		`}

	${({ $customWidth }) =>
		$customWidth &&
		css`
			width: ${$customWidth};
		`}

	svg {
		fill: ${({ theme: { colors } }) => colors.whiteAlways};
		display: block;
		height: 1em;

		${({ $customHeight }) =>
			$customHeight &&
			css`
				height: ${$customHeight};
			`};

		${({ $customVerticalAlign }) =>
			$customVerticalAlign &&
			css`
				vertical-align: ${$customVerticalAlign};
			`};
	}
`;
const SexIcon = ({
	customHeight,
	customMargin,
	customVerticalAlign,
	customWidth,
}) => {
	return (
		<StyledSvgIconContainer
			$customHeight={customHeight}
			$customMargin={customMargin}
			$customVerticalAlign={customVerticalAlign}
			$customWidth={customWidth}
		>
			<svg
				viewBox="0 0 18 14"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M7.19988 9.1875C7.19988 8.74453 7.23644 8.94961 4.80644 4.22461C4.30863 3.25938 2.88832 3.25664 2.39051 4.22461C-0.0591817 8.99063 -0.000119153 8.7582 -0.000119153 9.1875C-0.000119153 10.3961 1.61144 11.375 3.59988 11.375C5.58832 11.375 7.19988 10.3961 7.19988 9.1875ZM3.59988 4.8125L5.62488 8.75H1.57488L3.59988 4.8125ZM17.9999 9.1875C17.9999 8.74453 18.0364 8.94961 15.6064 4.22461C15.1086 3.25938 13.6883 3.25664 13.1905 4.22461C10.7408 8.99063 10.7999 8.7582 10.7999 9.1875C10.7999 10.3961 12.4114 11.375 14.3999 11.375C16.3883 11.375 17.9999 10.3961 17.9999 9.1875ZM12.3749 8.75L14.3999 4.8125L16.4249 8.75H12.3749ZM14.8499 12.25H9.89988V4.1918C10.5608 3.91016 11.0586 3.33047 11.2049 2.625H14.8499C15.0974 2.625 15.2999 2.42812 15.2999 2.1875V1.3125C15.2999 1.07187 15.0974 0.875 14.8499 0.875H10.7886C10.378 0.347266 9.73394 0 8.99988 0C8.26582 0 7.62176 0.347266 7.21113 0.875H3.14988C2.90238 0.875 2.69988 1.07187 2.69988 1.3125V2.1875C2.69988 2.42812 2.90238 2.625 3.14988 2.625H6.79488C6.94113 3.33047 7.43894 3.91016 8.09988 4.1918V12.25H3.14988C2.90238 12.25 2.69988 12.4469 2.69988 12.6875V13.5625C2.69988 13.8031 2.90238 14 3.14988 14H14.8499C15.0974 14 15.2999 13.8031 15.2999 13.5625V12.6875C15.2999 12.4469 15.0974 12.25 14.8499 12.25Z"
					fill="#52C522"
				/>
			</svg>
		</StyledSvgIconContainer>
	);
};

export default SexIcon;
